// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"2ffd9903253799caf115","873":"0e9b809e6a2dc6953e88"}[chunkId] + ".js";
};